import { Component, Input } from '@angular/core';
import { NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault, NgTemplateOutlet } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { NbCardModule, NbPopoverModule, NbInputModule, NbDatepickerModule, NbSelectModule, NbOptionModule, NbIconModule, NbButtonModule, NbSpinnerModule } from '@nebular/theme';
import { NgLetModule } from 'ng-let';
import { WalletInfoCardComponent } from '../../../pages/dashboard/wallet-info-card/wallet-info-card.component';
import { BaseCreatingEditing } from '../../../shared-classes/BaseCreatingEditing';
import { entryProp } from '../../../interfaces/apiCalls';
import { StatusIconDirective } from '../../../directives/status-icon.directive';

@Component({
  selector: 'app-date-input',
  standalone: true,
  imports: [NgIf, WalletInfoCardComponent, NbCardModule, FormsModule, ReactiveFormsModule, NgFor, NbPopoverModule, NgSwitch, NgSwitchCase, NbInputModule, NbDatepickerModule, NbSelectModule, NbOptionModule, NgSwitchDefault, NbIconModule, NbButtonModule, MatRippleModule, NbSpinnerModule, NbDateFnsDateModule, NgLetModule, NgTemplateOutlet, StatusIconDirective],
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent {

  @Input('parentRef') parent: BaseCreatingEditing;
  @Input() field : entryProp ; // this is the form field ref, it is passed here from a template variable of the parent component and is not defined on the parent component itself !
  
}
